<template>
  <div>
    <treeselect
      v-model="value"
      :multiple="false"
      :cacheOptions="false"
      :defaultExpandLevel="2"
      :normalizer="typeIdsNormalizer"
      :placeholder="placeholder"
      :options="options"
      :alwaysOpen="alwaysOpen"
      :searchable="true"
      @select="select"
      @input="input"
      :disabled="isDisabled === '3' || isDisabled === '4'"
    >
      <label
        slot="option-label"
        slot-scope="{ node, labelClassName }"
        :class="labelClassName"
      >
        <span :title="node.label" v-text="node.label" class="showname"
          >({{ node.label }})</span
        >
      </label>
    </treeselect>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  mounted() {
    this.admin = sessionStorage.getItem("admin");
    // console.log(this.option);
    // console.log(this.treeValue)
    //数据处理
    // this.treeValue!=null?this.getValue():''
    this.value = this.treeValue;
    this.detailChange();
  },
  props: {
    option: {
      type: Array,
      default() {
        return [];
      },
    },
    treeValue: {
      type: Number | String,
      default() {
        return null;
      },
    },
    alwaysOpen: {
      type: Boolean,
      default() {
        return false;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return true;
      },
    },
    placeholder: {
      type: String,
      default() {
        return "请输入...";
      },
    },
  },
  components: { Treeselect },
  data() {
    return {
      isDisabled: sessionStorage.getItem("grp"),

      admin: "",
      typeIdsNormalizer(node) {
        // console.log(node);
        // 自定义派单大小类树键名
        return {
          id: node.id,
          label: node.name,
        };
      },
      value: null,
      // define options
      options: [],
    };
  },
  methods: {
    select(node, instanceId) {
      this.$emit("treeValue", node.id);
      this.$emit("treeValueLevel", node.level);
      this.$emit("treeValueParentId", node.id);
      this.$emit("treeAll", node);
      console.log(node);
    },
    input(node, instanceId) {
      this.$emit("treeAllInput", node);
      if (node == undefined) {
        this.$emit("reset", "");
      }
      //  console.log(node)
    },
    //数据处理
    detailChange() {
      var obj = [];
      var need = [];
      var last = this.option.length;
      var arr = JSON.parse(JSON.stringify(this.option));
      for (var j = 0; j < last; j++) {
        //控制次数
        for (var i = 0; i < arr.length; i++) {
          //每次循环筛选
          if (arr[i].level == j) {
            obj[j] = obj[j] ? obj[j] : [];
            obj[j].push(arr[i]);
          }
        }
      }
      need = obj;

      if (sessionStorage.getItem("grp") === "2") {
        for (var k = obj.length - 1; k > 0; k--) {
          for (var x = 0; x < obj[k].length; x++) {
            for (var y = 0; y < obj[k - 1].length; y++) {
              if (obj[k][x].parentId == need[k - 1][y].id) {
                need[k - 1][y].children = need[k - 1][y].children
                  ? need[k - 1][y].children
                  : [];
                need[k - 1][y].children.push(obj[k][x]);
              }
            }
          }
        }
        need[0].find((item) => {
          item.children.find((item1) => {
            if (item1.id == sessionStorage.getItem("orgId")) {
              this.options = [item1];
            }
          });
        });
      } else {
        for (var k = obj.length - 1; k > 0; k--) {
          for (var x = 0; x < obj[k].length; x++) {
            for (var y = 0; y < obj[k - 1].length; y++) {
              if (obj[k][x].parentId == need[k - 1][y].id) {
                need[k - 1][y].children = need[k - 1][y].children
                  ? need[k - 1][y].children
                  : [];
                need[k - 1][y].children.push(obj[k][x]);
              }
            }
          }
        }
        this.options = need[0];
      }
    },
    getValue() {
      this.option.forEach((elem) => {
        if (this.treeValue == elem.code) {
          this.value = elem.id;
        }
      });
    },
  },
};
</script>

<style scoped>
.showname {
  width: 200px;
  overflow: hidden !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  display: block !important;
}
</style>